<template>
  <div class="d-flex align-items-center">
    <i :class="statusDetails.icon"></i>
    <span class="status-label label bold text-nowrap text-medium" :data-status="status">{{
      statusDetails.label
    }}</span>
  </div>
</template>

<script>
import * as R from 'ramda'
import { STATUS } from '@/constants/initiative'

/**
 * This component shows initiative status's label with its icon
 */
export default {
  name: 'InitiativeStatusLabel',
  props: ['status'],
  computed: {
    statusDetails() {
      return Object.values(STATUS).find(R.propEq('id', this.status))
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_styleConfigurations.scss';

/*
Initiative statuses
 */
$initiative-in-progress: #1d61f5;
$initiative-at-risk: $error;
$initiative-not-started: $secondary;
$initiative-done: $active;

.label {
  margin-left: 6px;

  &[data-status='at-risk'] {
    color: $initiative-at-risk;
  }
  &[data-status='not-started'] {
    color: $initiative-not-started;
  }
  &[data-status='done'] {
    color: $initiative-done;
  }
  &[data-status='on-track'] {
    color: $initiative-in-progress;
  }
}
</style>
